import { render } from "./LabelsData.vue?vue&type=template&id=478d8994"
import script from "./LabelsData.vue?vue&type=script&lang=js"
export * from "./LabelsData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__